var map = {
	"./de-CH/storefront-app.json": [
		64938,
		4938
	],
	"./de-DE/storefront-app.json": [
		56790,
		6790
	],
	"./en-CH/storefront-app.json": [
		63969,
		3969
	],
	"./en-GB/storefront-app.json": [
		14095,
		4095
	],
	"./en-US/storefront-app.json": [
		40075,
		75
	],
	"./es-ES/storefront-app.json": [
		57706,
		7706
	],
	"./fr-CH/storefront-app.json": [
		81594,
		1594
	],
	"./fr-FR/storefront-app.json": [
		85382,
		5382
	],
	"./it-CH/storefront-app.json": [
		25591,
		5591
	],
	"./it-IT/storefront-app.json": [
		66614,
		6614
	],
	"./ja-JP/storefront-app.json": [
		26909,
		6909
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 87535;
module.exports = webpackAsyncContext;